import { useMutation } from "@tanstack/react-query";
import { registerFace, requestProps } from "@/api/face-registration.ts";
import { RequestError } from "@/axios/schema.ts";

export const useFaceRegistration = () => {
	return useMutation<void, RequestError, requestProps>({
		mutationFn: registerFace,
	});
};
